import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { QuizSubject } from '../../../interfaces/question.interface';
import { GameModeService } from '../../../_services/game-mode.service';
import { MiniGameService } from '../../../_services/mini-game.service';
import { GamePhase } from '../../../interfaces/game-state.interface';
import { getDailyBonusTopic } from '../../../data/league-config';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-subject-picker',
  templateUrl: './subject-picker.component.html',
  styleUrls: ['./subject-picker.component.scss']
})
export class SubjectPickerComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  currLang: any = 'en';
  dailyBonusSubject: QuizSubject | 'random';

  subjects: { key: QuizSubject | 'random'; icon: string; color: string }[] = [
    { key: 'random', icon: '&#127922;', color: '#607D8B' },
    { key: QuizSubject.MATH, icon: '&#128290;', color: '#4CAF50' },
    { key: QuizSubject.SCIENCE, icon: '&#128300;', color: '#2196F3' },
    { key: QuizSubject.ARABIC, icon: '&#128214;', color: '#9C27B0' },
    { key: QuizSubject.ENGLISH, icon: '&#127468;&#127463;', color: '#FF9800' },
    { key: QuizSubject.ISLAMIC, icon: '&#9770;', color: '#009688' },
    { key: QuizSubject.GENERAL, icon: '&#127758;', color: '#795548' },
  ];

  constructor(
    private gameModeService: GameModeService,
    private miniGameService: MiniGameService,
    private globalService: GlobalService
  ) {
    this.dailyBonusSubject = getDailyBonusTopic().subject;
  }

  ngOnInit(): void {
    this.globalService.getLang()
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => this.currLang = lang);

    // Phase 1: auto-start game cycle on first entry
    if (this.gameModeService.autoStartOnEntry) {
      this.gameModeService.autoStartOnEntry = false;
      this.miniGameService.enableAutoCycle();
      this.miniGameService.startNextAutoCycleGame();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  selectSubject(subject: QuizSubject | 'random'): void {
    this.miniGameService.setSelectedSubject(subject);
    this.gameModeService.setPhase(GamePhase.GAME_SELECT);
  }

  goBack(): void {
    // Phase 1: no HUB screen, close the game entirely
    this.gameModeService.closeGame();
  }

  isBonus(key: QuizSubject | 'random'): boolean {
    return key === this.dailyBonusSubject;
  }
}
